import { ChangeDetectionStrategy, Component, signal } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";
import { UserRolePermissionsService } from "src/app/shared/services/user-role-permissions/user-role-permissions.service";

import { InspectionCommonData } from "../../model/inspection-common-data";
import { InspectionState } from "../../model/inspection-state";
import { InspectionDetailsService } from "../../services/inspection-details.service";
import { InspectionDetailsBase } from "../inspection-details-base";
import { PermissionsService } from "./../../services/permissions.service";

@Component({
  selector: "im-inspection-details-sow",
  templateUrl: "./inspection-details-sow.component.html",
  styleUrl: "./inspection-details-sow.component.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class InspectionDetailsSowComponent extends InspectionDetailsBase {
  public isReadOnly: boolean = false;
  public isLoading = signal<boolean>(false);
  private inspectionCommonDataSubscription: Subscription;

  constructor(
    route: ActivatedRoute,
    private permissionsService: PermissionsService,
    private inspectionDetailsService: InspectionDetailsService,
    private userRolePermissionsService: UserRolePermissionsService,
  ) {
    super(route);
  }

  public async ngOnInit() {
    this.isLoading.set(true);
    const permissions = await this.permissionsService.getPermissions();
    this.isReadOnly = permissions.setScopeOfWorkConfig().isReadOnly;
    this.subscribeToInspectionCommonData();
  }

  public ngOnDestroy() {
    this.inspectionCommonDataSubscription?.unsubscribe();
  }

  public onChildLoaded(): void {
    this.isLoading.set(false);
  }

  private subscribeToInspectionCommonData(): void {
    this.inspectionCommonDataSubscription =
      this.inspectionDetailsService.inspectionCommonData.subscribe(
        (inspectionCommonData: InspectionCommonData) => {
          if (
            !this.userRolePermissionsService.isInspector() &&
            !this.userRolePermissionsService.isServiceProviderInspector()
          ) {
            this.isReadOnly =
              inspectionCommonData?.state == InspectionState.Closed ||
              this.userRolePermissionsService.isReadOnly();
          } else {
            this.isReadOnly =
              inspectionCommonData?.state == InspectionState.Closed ||
              inspectionCommonData?.state == InspectionState.Finished;
          }
        },
      );
  }
}
